import styled from 'styled-components';

import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';

export const BodyText = styled(BaseBodyText)`
  text-align: center;
`;

export const CodeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InstructionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CodeInputStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
